import React, { useState, useEffect, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';
import RenderCustomFieldValues from './render-custom-field-item-values';
import AccordionItem from './accordion-item';
import { ErrorContainer } from './styles';

const RenderCustomFields = ({
  fields,
  remove,
  forceError
}) => {
  const { watch, formState: { errors } } = useFormContext();
  const items = watch('customFields') ?? [];
  const error = errors.customFields?.root?.message ?? errors.customFields?.message;

  const [expanded, setExpanded] = useState(
    fields.length ? `customFields[${fields.length - 1}]` : false
  );

  const handleSetExpanded = useCallback(panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }, []);

  useEffect(() => {
    if (fields.length) {
      setExpanded(`customFields[${fields.length - 1}]`);
    }
  }, [fields.length]);

  if (!fields.length) {
    return null;
  }

  return (
    <ErrorContainer hasError={Boolean(error)}>
      {fields.map((field, index) =>
        <AccordionItem
          index={index}
          member={`customFields[${index}]`}
          remove={() => remove(index)}
          expanded={expanded === `customFields[${index}]`}
          handleSetExpanded={handleSetExpanded}
          item={items[index] ?? field}
          forceError={forceError}
          key={field.fieldId}
          placeholder="Custom field name"
        >
          <RenderCustomFieldValues
            memberIndex={index}
            parentMember={`customFields[${index}]`}
            forceError={forceError}
          />
        </AccordionItem>)}
      {error && <Typography align="left" color="error">{error}</Typography>}
    </ErrorContainer>
  );
};

export default RenderCustomFields;
